/**
 * Copyright by INSIDE M2M GmbH and the authors 2004 - 2018
 *
 *************************************************************
 ********************* CONFIDENTIAL **************************
 *************************************************************
 *
 */
import { Action } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { first } from 'rxjs/operators';

export class ApiCallService {
    private notifications: Map<string, Subject<Action>> = new Map();
    register(actionType: string): Observable<any> {
        const s = new Subject<Action>();
        this.notifications.set(actionType, s);
        return s.pipe(first());
    }

    notify<T extends Action>(a: T, error?: boolean) {
        const s = this.notifications.get(a.type);
        if (s) {
            if (error) {
                s.error(a);
            } else {
                s.next(a);
            }
            this.notifications.delete(a.type);
        }
    }
}

export const apiCallService = new ApiCallService();
